import type { IsoItemApplicability, SoaControlTheme, SoaImplementationStatus } from './types';

export const SOA_THEME_LABEL: Record<SoaControlTheme, string> = {
  organizativos: 'Organizativos (A.5)',
  personas: 'Personas (A.6)',
  fisicos: 'Físicos (A.7)',
  tecnologicos: 'Tecnológicos (A.8)',
};

export const SOA_STATUS_LABEL: Record<SoaImplementationStatus, string> = {
  pendiente: '— Pendiente',
  planificado: 'Planificado',
  en_proceso: 'En proceso',
  implementado: 'Implementado',
  verificado: 'Verificado',
};

export const SOA_APPLICABILITY_LABEL: Record<IsoItemApplicability, string> = {
  sin_definir: 'Sin definir',
  aplica: 'Aplica',
  no_aplica: 'No aplica',
};

export function implementationStatusBadgeClass(status: SoaImplementationStatus): string {
  switch (status) {
    case 'verificado':
      return 'bg-emerald-100 text-emerald-800';
    case 'implementado':
      return 'bg-sky-100 text-sky-800';
    case 'en_proceso':
    case 'planificado':
      return 'bg-amber-100 text-amber-900';
    default:
      return 'bg-muted text-muted-foreground';
  }
}

export const SOA_THEME_ORDER: SoaControlTheme[] = [
  'organizativos',
  'personas',
  'fisicos',
  'tecnologicos',
];

export const SOA_STATUS_ORDER: SoaImplementationStatus[] = [
  'pendiente',
  'planificado',
  'en_proceso',
  'implementado',
  'verificado',
];
